var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import BillHeader from './components/BillHeader';
import LeftTree from './components/LeftTree';
import CategoryTable from './components/CategoryTable';
import CategoryService from '../../api/CategoryService';
import { Loading } from 'element-ui';
var GoodCategory = (function (_super) {
    __extends(GoodCategory, _super);
    function GoodCategory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.total = 100;
        _this.data = [];
        _this.selectRows = [];
        _this.categoryId = 0;
        _this.treeData = [];
        _this.categoryIconList = [];
        _this.defaultCategoryIconUrl = '';
        return _this;
    }
    GoodCategory.prototype.mounted = function () {
        this.service = CategoryService.getInstance();
        this.getTreeCategoryData();
        this.getCategoryIconList();
    };
    GoodCategory.prototype.nodeClick = function (node) {
        if (node && node.goods_type_id) {
            this.categoryId = node.goods_type_id;
            var pagination = this.$refs.pagination;
            pagination.clear();
            this.search(pagination.getPage());
        }
    };
    GoodCategory.prototype.getTreeCategoryData = function () {
        var _this = this;
        this.service.getCategoryTree().then(function (res) {
            _this.treeData = res.data.data;
        });
    };
    GoodCategory.prototype.getCategoryIconList = function () {
        var _this = this;
        this.service.getCategoryIconList().then(function (res) {
            _this.categoryIconList = res.data.data;
            if (_this.categoryIconList && _this.categoryIconList.length > 0)
                _this.defaultCategoryIconUrl = _this.categoryIconList[0].goods_type_icon_url;
        });
    };
    GoodCategory.prototype.pageChange = function (pager) {
        this.search(pager);
    };
    GoodCategory.prototype.search = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        var categoryId = this.categoryId;
        if (!categoryId && this.treeData && this.treeData.length > 0) {
            categoryId = this.treeData[0].goods_type_id;
        }
        this.service.getCategoryList(Object.assign({}, pager, { goods_type_id: categoryId })).then(function (res) {
            loadingInstance.close();
            _this.data = res.data.data;
            _this.total = res.data.total;
        }, function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    GoodCategory.prototype.setSelectRows = function (rows) {
        this.selectRows = rows;
    };
    GoodCategory = __decorate([
        Component({
            components: {
                'bill-header': BillHeader,
                'left-tree': LeftTree,
                'category-table': CategoryTable
            }
        })
    ], GoodCategory);
    return GoodCategory;
}(Vue));
export default GoodCategory;
